// PROV: Phase-1 clinical provenance — pure helpers (no transport; node-testable)
export const PROV_SCHEMA_VERSION = "1.0";

export const genId = () => {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch (e) { /* fall through */ }
  return `p-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

export const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);

// Reproducible candidate id: session + section + rule key + index + molecule
export const recId = (gSess, section, key, index, molecule) => `${gSess}:${section}:${key || "-"}:${index}:${slug(molecule)}`;

// Minimum-necessary clinical fields for a medicine event (spec §13)
export const medEventFields = (row) => ({
  brand_name: row?.brand_name || "",
  generic_name: row?.generic_name || "",
  composition: row?.composition || "",
  strength: row?.strength || "",
  dose: row?.dose || "",
  route: row?.route || "",
  frequency: row?.frequency || "",
  duration: row?.duration || "",
  medicine_id: row?.medicine_id || null,
  type: row?.type || null,
  // MT-11B.7/B.8: strength-vs-dose + original↔corrected values travel with every event/snapshot
  ...(row?.concentration ? { concentration: row.concentration } : {}),
  ...(row?.dose_unit ? { dose_unit: row.dose_unit } : {}),
  ...(row?.split_confirmed ? { split_confirmed: true, admin_quantity: row.admin_quantity || "" } : {}),
  ...(row?.correction?.original ? { correction: row.correction } : {}),
  ...(row?.search_group ? { search_group: row.search_group } : {}),
  ...(row?.quality_confirmations?.length ? { quality_confirmations: row.quality_confirmations } : {}),
});

// Deterministic origin classification — never guesses:
//  1. non-PHYSICIAN _prov tags (system origins + carried_over UNKNOWN) always win
//  2. medicine_id is only ever set by the typeahead pick → PHYSICIAN/manual_pick
//  3. PHYSICIAN tags (free_text / template) kept as tagged
//  4. anything untagged predates provenance → UNKNOWN/pre_provenance (spec §15)
export const originOfRow = (row) => {
  const p = row?._prov;
  if (p?.origin && p.origin !== "PHYSICIAN") return { origin: p.origin, detail: p.detail || null };
  if (row?.medicine_id) return { origin: "PHYSICIAN", detail: "manual_pick" };
  if (p?.origin === "PHYSICIAN") return { origin: "PHYSICIAN", detail: p.detail || null };
  return { origin: "UNKNOWN", detail: "pre_provenance" };
};
